import { Controller } from "stimulus"
import Cookies from "js-cookie"

export default class extends Controller {
  connect() {
  }

  changeTab(event) {
    Cookies.set('business_unit_id', $(event.target).data("tab-id"))
    Turbolinks.visit($(event.target).data("url"))
  }
}
